export default __webpack_public_path__ + "static/media/RisingSunDarkIcon.02871dfa.svg";